// TranscriptRenderer.jsx - Updated to remove excerpts and effectiveSelect
import React, { useCallback } from 'react';
import { PARAGRAPH_PADDING } from 'constants/DimensionsConstants';
import CodeableWrapper from 'codeable/CodeableWrapper';
import { useTranscriptData } from 'hooks/useTranscriptData';
import ParagraphRenderer from './ParagraphRenderer';
import { useInitializeParagraphExcerpts } from 'hooks/transcripts/queries';

const TranscriptRenderer = ({
  transcriptID,
  transcriptText,
  coders = null,
  selectedExcerptId,
  select,
  page,
  isPrint,
  hasEditPermission,
  title,
  bodyRef,
  setParagraphRef,
  onSelectText,
  onExcerptSelected,
  onDeselect,
  onParagraphClick
}) => {  
  // Initialize paragraph excerpt mappings
  useInitializeParagraphExcerpts(transcriptID);

  // Use shared transcript data processing
  const { paragraphs, speakerColorHash, paginationInfo, visibleParagraphs } = useTranscriptData(
    transcriptText, 
    page
  );

  // Handle paragraph click
  const handleParagraphClick = useCallback((start, end) => {
    if (onParagraphClick) {
      onParagraphClick(start, end);
    }
  }, [onParagraphClick]);

  const paragraphPadding = `${PARAGRAPH_PADDING}px`;
  
  // When printing, show all paragraphs instead of just the visible ones for the current page
  const paragraphsToRender = isPrint ? paragraphs : visibleParagraphs;

  return (
    <CodeableWrapper
      isPrint={isPrint}
      hasEditPermission={hasEditPermission}
      onSelectExcerpt={onExcerptSelected}
      onDeselect={onDeselect}
      onSelectText={onSelectText}
      codeableType="Transcript"
      codeableId={transcriptID}
    >
      <div ref={bodyRef} style={{ margin: 0, padding: '20px 10px' }}>
        {title && (
          <div style={{ paddingLeft: paragraphPadding }}>
            <h3>{title}</h3>
          </div>
        )}
        <ParagraphRenderer
          visibleParagraphs={paragraphsToRender}
          transcriptID={transcriptID}
          speakerColorHash={speakerColorHash}
          select={select}
          selectedExcerptId={selectedExcerptId}
          canEdit={!isPrint && !!hasEditPermission}
          isPrint={!!isPrint}
          hasEditPermission={!!hasEditPermission}
          onParagraphClick={handleParagraphClick}
          setParagraphRef={setParagraphRef}
          layout="single"
          leftUserID={(coders || [])[0]}
        />
        {isPrint && paragraphsToRender?.length > 0 && (
          <div style={{ paddingLeft: paragraphPadding }}>
            <hr style={{ borderWidth: '0px' }} />
            Created with the <a href="http://www.delvetool.com">Delve Qualitative Analysis Tool </a>
          </div>
        )}
      </div>
    </CodeableWrapper>
  );
};

export default TranscriptRenderer;